export default "__VITE_ASSET__uYUuM_Cb__"